module.exports = __webpack_public_path__ + "static/media/HCMM777.e5df7482.jpg";